import { LightPathDTO } from 'business/models/Models';
import Well, { Props as WellProps } from 'components/plateviewer/well/Well';
import React, { memo, useState } from 'react';

export type Props = Omit<
  WellProps,
  'drawingFetched' | 'setDrawingFetched' | 'lightPaths' | 'setLightPaths'
>;
const WellContainer = (props: Props) => {
  const [lightPaths, setLightPaths] = useState<LightPathDTO[]>([]);
  const [drawingFetched, setDrawingFetched] = useState<boolean>(false);
  return (
    <Well
      drawingFetched={drawingFetched}
      setDrawingFetched={setDrawingFetched}
      setLightPaths={setLightPaths}
      lightPaths={lightPaths}
      {...props}
    />
  );
};

export default memo(WellContainer);
